import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import { validate } from '@adornis/validation/decorators.js';
import { nonOptional } from '@adornis/validation/functions/nonOptional.js';
import { DateTime } from 'luxon';
import { CapacityRequest, type CapacityRequestType } from './CapacityRequest.js';
import { DataLoadedField } from '@adornis/baseql/decorators/data-loaded-field.js';
import { KPF } from '@chancenwerk/master-data-management/kpf/entities/KPF.js';

@Entity()
export class CapacityGuestDay extends MongoEntity {
  static override _class = 'CapacityGuestDay';
  static override _collectionName = 'capacity-guest-days';

  @validate(nonOptional())
  @Field(type => String)
  public requestId: Maybe<string>;

  @DataLoadedField(type => CapacityRequest, ({ requestId }) => requestId)
  public request: Maybe<CapacityRequest>;

  @validate(nonOptional())
  @Field(type => DateTime)
  public day: Maybe<DateTime>;

  @Field(type => String)
  public vorname: Maybe<string>;

  @Field(type => String)
  public nachname: Maybe<string>;

  @Field(type => String)
  public telefonBewerber: Maybe<string>;

  @Field(type => String)
  public bewerbungslink: Maybe<string>;

  @Field(type => DateTime, { default: v => v ?? DateTime.now() })
  public createdAt: Maybe<DateTime>;

  @validate(nonOptional())
  @Field(type => String)
  public KPFID: Maybe<string>;

  @DataLoadedField(type => KPF, ({ KPFID }) => KPFID)
  public KPF: Maybe<KPF>;
}
